<template>
    <div v-if="token">
      <v-btn @click="logout">
        <span class="mr-2">Logout</span>
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </div>
    <div v-else>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn dark v-on="on">
            <span class="mr-2">Login/Register</span>
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">User Profile</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Mobile/Nickname*"
                    v-model="login"
                    required
                    rounded
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Password*"
                    type="password"
                    v-model="password"
                    required
                    rounded
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="getToken">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
      dialog: false,
      login: '',
      password: ''
    }),
  name: 'Login',
  methods: {
    ...mapActions(['fetchToken', 'fetchUser', 'logout']),
    getToken () {
      this.fetchToken({ username: this.login, password: this.password})
      this.dialog = false
    }
  },
  computed: mapGetters(['token', 'user'])
}
</script>